import {
  ISection,
  IGenericSubSection,
  ITriageSubSection,
  IActionSectionChecklist,
  ISectionChecklist,
  ChecklistItemType,
  ActionItem,
  IChecklistActionItem,
  TriageItem,
  IChecklistTriageItem,
  SectionTitle,
} from './QMWorkflowTypes';

const createOverviewSection = (): ISection => {
  // section checklist
  const overviewSectionChecklist: ISectionChecklist = {
    title: 'This page is under construction. 🚧',
    children: [],
  };
  // subsection
  const overviewSubSection: IGenericSubSection = {
    title: 'Overview',
    children: [overviewSectionChecklist],
  };
  // section
  const overviewSection: ISection = {
    title: SectionTitle.Overview,
    children: [overviewSubSection],
  };
  return overviewSection;
};

const createAutopilotSection = (): ISection => {
  const promoteAttemptersToSpotters: IChecklistActionItem = {
    text: '',
    buttonText: 'Promote: Attempters to Spotters',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PromoteAttemptersToSpotters,
  };

  const demoteSpottersToAttempters: IChecklistActionItem = {
    text: '',
    buttonText: 'Demote: Spotters to Attempters',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.DemoteSpottersToAttempters,
  };

  const permissionManagementChecklist: ISectionChecklist = {
    title: 'Permissions & Contributors',
    children: [promoteAttemptersToSpotters, demoteSpottersToAttempters],
    hideCheckboxes: true,
  };

  // subsection
  const permissioningSubSection: IGenericSubSection = {
    title: 'Inline Tools',
    children: [permissionManagementChecklist],
  };
  // section
  const permissioningSection: ISection = {
    title: SectionTitle.Autopilot,
    children: [permissioningSubSection],
  };
  return permissioningSection;
};

const createSpotterPipelineSection = (): ISection => {
  // checklist items
  const permSuperAttempters: IChecklistActionItem = {
    text: '',
    buttonText: 'Permission & Assign: Super Attempters',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignSuperAttempters,
  };

  const permSpotters: IChecklistActionItem = {
    text: '',
    buttonText: 'Permission & Assign: Spotters',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignSpotters,
  };

  const demoteSuperAttempters: IChecklistActionItem = {
    text: '',
    buttonText: 'Demote: Super Attempters to L0',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.DemoteSuperAttempters,
  };

  const demoteSpotters: IChecklistActionItem = {
    text: '',
    buttonText: 'Demote: Spotters to L1',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.DemoteSpotters,
  };

  // TODO: This action is a fill in action for now, will be edited in the next couple days. Give this section a proper action
  const taskManagementSubtaskReservation: IChecklistActionItem = {
    text: '',
    buttonText: 'Reserve Subtasks for Zero Review',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.SubtaskReservation,
  };

  const taskManagementRecallSuperAttempterTasks: IChecklistActionItem = {
    text: '',
    buttonText: 'Recall Super Attempter Tasks',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.MoveTasksInPipeline,
  };

  const taskManagementReleaseAuditStages: IChecklistActionItem = {
    text: '',
    buttonText: 'Release Audit Stages',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.ReleaseAuditStages,
  };

  const qualityDecisionTree: IChecklistActionItem = {
    text: '',
    buttonText: 'Spotter Performance Decision Tree',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.SpotterPerformanceDecisionTree,
  };

  const qualityManualMonitoring: IChecklistActionItem = {
    text: '',
    buttonText: 'Spotter Quality Manual Monitoring',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.SpotterQualityManualMonitoring,
  };

  const spotterAuditTool: IChecklistActionItem = {
    text: '',
    buttonText: 'Spotter Audit Tool',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.SpotterAuditTool,
  };

  const permissionManagementChecklist: ISectionChecklist = {
    title: 'Permissions & Contributors',
    children: [permSuperAttempters, permSpotters, demoteSuperAttempters, demoteSpotters],
    hideCheckboxes: true,
  };

  const taskManagementChecklist: ISectionChecklist = {
    title: 'Task Management',
    children: [
      taskManagementSubtaskReservation,
      taskManagementRecallSuperAttempterTasks,
      taskManagementReleaseAuditStages,
    ],
    hideCheckboxes: true,
  };

  const qualityChecklist: ISectionChecklist = {
    title: 'Quality',
    children: [qualityDecisionTree, qualityManualMonitoring, spotterAuditTool],
    hideCheckboxes: true,
  };

  // subsection
  const monitoringSpotterPipelineubSection: IGenericSubSection = {
    title: 'Inline Tools',
    children: [permissionManagementChecklist, taskManagementChecklist, qualityChecklist],
  };
  // section
  const monitoringSpotterPipelineSection: ISection = {
    title: SectionTitle.SpotterPipeline,
    children: [monitoringSpotterPipelineubSection],
  };
  return monitoringSpotterPipelineSection;
};

const createMonitoringThroughputSection = (): ISection => {
  // checklist items
  const sendTasksToCustomer: IChecklistActionItem = {
    text: '',
    buttonText: 'Send Tasks to Customer',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.SendTasksToCustomer,
  };
  const moveTasks: IChecklistActionItem = {
    text: '',
    buttonText: 'Move Tasks in Pipeline',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.MoveTasksInPipeline,
  };
  const moveTasksPipelineV3: IChecklistActionItem = {
    text: '',
    buttonText: 'Move Tasks in PipelineV3',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.MoveTasksInPipelineV3,
  };
  const quarantineTasks: IChecklistActionItem = {
    text: '',
    buttonText: 'Quarantine/Unquarantine Tasks or Subtasks',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.QuarantineAndUnquarantineSubtasks,
  };
  const throttles: IChecklistActionItem = {
    text: '',
    buttonText: 'Throttles',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.Throttles,
  };

  const workerSources: IChecklistActionItem = {
    text: '',
    buttonText: 'Worker Sources',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.WorkerSources,
  };
  const permAttempters: IChecklistActionItem = {
    text: '',
    buttonText: 'Permission & Assign: Attempters',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignAttempters,
  };
  const permReviewers: IChecklistActionItem = {
    text: '',
    buttonText: 'Permission & Assign: Reviewers',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignReviewers,
  };
  const permQIRAuditors: IChecklistActionItem = {
    text: '',
    buttonText: 'Permission & Assign: PipelineV3 QIR Auditors',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignPipelineV3QIRAuditors,
  };
  const demoteReviewers: IChecklistActionItem = {
    text: '',
    buttonText: 'Demote Reviewers to Attempters',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.DemoteReviewers,
  };
  const disableProject: IChecklistActionItem = {
    text: '',
    buttonText: 'Mass Disable Contributors',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.MassDisableTaskers,
  };
  const unassignProject: IChecklistActionItem = {
    text: '',
    buttonText: 'Mass Unassign Contributors',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.MassUnassignProject,
  };
  const retroActiveEnableDisable: IChecklistActionItem = {
    text: '[Advanced]',
    buttonText: 'Retroactive Enable/Disable',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.RetroactiveEnableDisable,
  };

  const corpExplain: IChecklistActionItem = {
    text: '',
    buttonText: 'Corp Explain',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.CorpExplain,
  };
  const supplyLeverChecks: IChecklistActionItem = {
    text: '',
    buttonText: 'Supply Lever Validity',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.MisconfiguredSupplyLevers,
  };
  const tableauAccess: IChecklistActionItem = {
    text: '',
    buttonText: 'Capacity Allocation View',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.CapacityAllocation,
  };

  const taskManagementChecklist: ISectionChecklist = {
    title: 'Task Management',
    children: [sendTasksToCustomer, moveTasks, moveTasksPipelineV3, quarantineTasks, throttles],
    hideCheckboxes: true,
  };
  const permissionManagementChecklist: ISectionChecklist = {
    title: 'Permission Management',
    children: [
      workerSources,
      permAttempters,
      permReviewers,
      permQIRAuditors,
      demoteReviewers,
      disableProject,
      unassignProject,
      retroActiveEnableDisable,
    ],
    hideCheckboxes: true,
  };
  const troubleShootingChecklist: ISectionChecklist = {
    title: 'Troubleshooting',
    children: [corpExplain, supplyLeverChecks, tableauAccess],
    hideCheckboxes: true,
  };

  // subsection
  const monitoringThroughputSubSection: IGenericSubSection = {
    title: 'Inline Tools',
    children: [taskManagementChecklist, permissionManagementChecklist, troubleShootingChecklist],
  };
  // section
  const monitoringThroughputSection: ISection = {
    title: SectionTitle.Throughput,
    children: [monitoringThroughputSubSection],
  };

  return monitoringThroughputSection;
};

const createMonitoringQualitySection = (): ISection => {
  // checklist items
  const generateConfMatrix: IChecklistActionItem = {
    text: '[TextCollection Only]',
    buttonText: 'Generate Confusion Matrix',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.GenerateConfusionMatrix,
  };
  // section checklist
  const monitoringQualitySectionChecklist: ISectionChecklist = {
    title: '',
    children: [generateConfMatrix],
    hideCheckboxes: true,
  };
  // subsection
  const monitoringQualitySubSection: IGenericSubSection = {
    title: 'Inline Tools',
    children: [monitoringQualitySectionChecklist],
  };
  // section
  const monitoringQualitySection: ISection = {
    title: SectionTitle.DisablingLinting,
    children: [monitoringQualitySubSection],
  };

  return monitoringQualitySection;
};

const createMonitoringBenchmarksSection = (): ISection => {
  const BenchmarkServingConfigs: IChecklistActionItem = {
    text: '',
    buttonText: 'Benchmark Serving Configs',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.BenchmarkServingConfigs,
  };
  const benchmarkNiceConfigs: IChecklistActionItem = {
    text: '',
    buttonText: 'Benchmark-Related Nice Configs',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.BenchmarkNiceConfigs,
  };
  const misconfiguredSupplyLevers: IChecklistActionItem = {
    text: '',
    buttonText: 'Misconfigured Supply Levers',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.MisconfiguredSupplyLevers,
  };
  const configureBenchmarks: IChecklistActionItem = {
    text: '',
    buttonText: 'Configure Specific Benchmarks',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.BenchmarkConfiguration,
  };
  const instructionItemManager: IChecklistActionItem = {
    text: '',
    buttonText: 'Instruction Item Manager',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.InstructionItemManager,
  };
  const monitoringBenchmarksSectionChecklist: ISectionChecklist = {
    title: '',
    children: [
      BenchmarkServingConfigs,
      benchmarkNiceConfigs,
      misconfiguredSupplyLevers,
      configureBenchmarks,
      instructionItemManager,
    ],
    hideCheckboxes: true,
  };
  const monitoringBenchmarksSubSection: IGenericSubSection = {
    title: 'Inline Tools',
    children: [monitoringBenchmarksSectionChecklist],
  };
  const monitoringBenchmarksSection: ISection = {
    title: SectionTitle.Benchmarks,
    children: [monitoringBenchmarksSubSection],
  };
  return monitoringBenchmarksSection;
};

const createMonitoringTrainingSection = (): ISection => {
  // checklist items
  const personalizedCourses: IChecklistActionItem = {
    text: '[TextCollection Only]',
    buttonText: 'Personalized Courses',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PersonalizedCourses,
  };

  const generateFeedbackCenter: IChecklistActionItem = {
    text: '[TextCollection Only]',
    buttonText: 'Generate Feedback Center',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.GenerateFeedbackCenter,
  };

  // section checklist
  const monitoringTrainingSectionChecklist: ISectionChecklist = {
    title: '',
    children: [personalizedCourses, generateFeedbackCenter],
    hideCheckboxes: true,
  };
  // subsection
  const monitoringTrainingSubSection: IGenericSubSection = {
    title: 'Inline Tools',
    children: [monitoringTrainingSectionChecklist],
  };
  // section
  const monitoringTrainingSection: ISection = {
    title: SectionTitle.Training,
    children: [monitoringTrainingSubSection],
  };
  return monitoringTrainingSection;
};

const createMonitoringIncentivesSection = (): ISection => {
  // checklist items
  const triageChecklist: IChecklistTriageItem = {
    text: 'This is a triage checklist item (monitoring/incentives section)',
    buttonText: 'A triage button',
    checklistType: ChecklistItemType.Triage,
    triageItem: TriageItem.Placeholder,
  };
  const actionChecklist: IChecklistActionItem = {
    text: 'This is an action checklist item (monitoring/incentives section)',
    buttonText: 'An action button',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.Placeholder,
  };
  // section checklist
  const monitoringIncentivesSectionChecklist: ISectionChecklist = {
    title: 'This is a monitoring/incentives section checklist',
    children: [triageChecklist, actionChecklist],
  };
  // subsection
  const monitoringIncentivesSubSection: IGenericSubSection = {
    title: 'Incentives',
    children: [monitoringIncentivesSectionChecklist],
  };
  // section
  const monitoringIncentivesSection: ISection = {
    title: SectionTitle.Incentives,
    children: [monitoringIncentivesSubSection],
  };
  return monitoringIncentivesSection;
};

const createZeroReviewSetupChecklist = (): ISection => {
  const saveMessage: IChecklistActionItem = {
    text: 'Spotter Config: Save Initial Message Config',
    buttonText: '',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignSuperAttempters,
  };
  const setPipelineConfig: IChecklistActionItem = {
    text: 'Spotter Config: Set Pipeline Configuration',
    buttonText: '',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignSuperAttempters,
  };
  const setSpotterPay: IChecklistActionItem = {
    text: 'Spotter Config: Set Spotter Payment',
    buttonText: '',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignSuperAttempters,
  };
  const setTaskHolding: IChecklistActionItem = {
    text: '0r Config: Set up Task Holdings. Use the strategy "zeroReview", enable for all your active review layers (except for L10), and input the Send to Audit Stage Rate (1 - L10 sample rate). Example: if you want 10% of the SAs’ tasks to go to L10 (spotters) then set the Send to Audit Stage Rate to 0.9.',
    buttonText: '',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignSuperAttempters,
  };
  const setAttempterPay: IChecklistActionItem = {
    text: '0r Config: Confirm that Attempter pay is set up',
    buttonText: '',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignSuperAttempters,
  };
  const createSlack: IChecklistActionItem = {
    text: 'Create a slack channel for all your spotters',
    buttonText: '',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignSuperAttempters,
  };
  const createNotionPage: IChecklistActionItem = {
    text: 'Create a Notion webpage for your spotters. This is how you will share instructions, update common errors, share bonus information, and more. Message Shawn Farsai for access to the Notion workspace. You can create a new Spotter Webpage for your project in the table here. Make sure you use the template by clicking the `new` dropdown and picking the templated highlighted in the image below',
    buttonText: '',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignSuperAttempters,
  };
  const zeroReviewOnboardingSectionChecklist: ISectionChecklist = {
    title: 'Have you properly setup zero review + spotter for this queue?',
    children: [
      saveMessage,
      setPipelineConfig,
      setSpotterPay,
      setTaskHolding,
      setAttempterPay,
      createSlack,
      createNotionPage,
    ],
  };

  // subsection
  const zeroReviewPlaceholder: IGenericSubSection = {
    title: 'Zero Review + Spotter Pipeline: Setup Checklist',
    children: [zeroReviewOnboardingSectionChecklist],
  };

  const mainSection: ISection = {
    title: SectionTitle.ZeroReviewSetupChecklist,
    children: [zeroReviewPlaceholder],
  };
  return mainSection;
};

const createZeroReviewPostSetupChecklist = (): ISection => {
  const spotOwnQueue: IChecklistActionItem = {
    text: 'Spend 1-2 hours spotting your own queue to learn the optimal workflow',
    buttonText: '',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignSuperAttempters,
  };
  const learnWorkflow: IChecklistActionItem = {
    text: 'Once you learn the workflow. Start filling out your Notion page with instructions and workflows for your spotters.',
    buttonText: '',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignSuperAttempters,
  };
  const findSpotters: IChecklistActionItem = {
    text: 'Find your spotters (don’t give them spotter permissions yet)',
    buttonText: 'Permission Spotters',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignSpotters,
  };
  const addToSlack: IChecklistActionItem = {
    text: 'Add them to slack, share the notion, and maybe even do an orientation webinar',
    buttonText: '',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignSuperAttempters,
  };
  const permissionSpotters: IChecklistActionItem = {
    text: 'Now give the spotters permissions',
    buttonText: 'Permission Spotters',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignSpotters,
  };
  const permissionSuperAttempters: IChecklistActionItem = {
    text: 'Promote Super Attempters',
    buttonText: 'Permission Super Attempters',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignSuperAttempters,
  };
  const zeroReviewOnboardingSectionChecklist: ISectionChecklist = {
    title: '',
    children: [
      spotOwnQueue,
      learnWorkflow,
      findSpotters,
      addToSlack,
      permissionSpotters,
      permissionSuperAttempters,
    ],
  };

  // subsection
  const zeroReviewPlaceholder: IGenericSubSection = {
    title: '',
    children: [zeroReviewOnboardingSectionChecklist],
  };

  const mainSection: ISection = {
    title: SectionTitle.ZeroReviewSetupChecklist,
    children: [zeroReviewPlaceholder],
  };
  return mainSection;
};

const createZeroReviewDailyChecklist = (): ISection => {
  const dailyChecklistStep1: IChecklistActionItem = {
    text: 'Check your Spotter TP and Spotter Send Rate',
    buttonText: '',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.TableauAccess,
  };
  const dailyChecklistStep2: IChecklistActionItem = {
    text: 'Not productive → Message those people in slack to see why they’re not working. Maybe you need to set a higher quota or change the pay formula',
    buttonText: '',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.TableauAccess,
    shouldIndent: true,
  };
  const dailyChecklistStep3: IChecklistActionItem = {
    text: 'Some spotters have a low send rate',
    buttonText: 'Spotter Quality Manual Monitoring',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.SpotterQualityManualMonitoring,
    shouldIndent: true,
  };
  const dailyChecklistStep4: IChecklistActionItem = {
    text: 'I need more spotters',
    buttonText: 'Permission & Assign: Spotters',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignSpotters,
    shouldIndent: true,
  };
  const dailyChecklistStep5: IChecklistActionItem = {
    text: 'Check your quality - QIR sores in the Deep dive dash',
    buttonText: '',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.TableauAccess,
  };
  const dailyChecklistStep6: IChecklistActionItem = {
    text: 'Is overall Spotters quality bad or just some spotters are bad?',
    buttonText: '',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.TableauAccess,
    shouldIndent: true,
  };
  const dailyChecklistStep7: IChecklistActionItem = {
    text: 'Some are bad',
    buttonText: 'Demote: Spotters to L1',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.DemoteSpotters,
    shouldDoubleIndent: true,
  };
  const dailyChecklistStep8: IChecklistActionItem = {
    text: 'Overall quality is bad → You need to calibrate your spotters and teach them to be stricter. ',
    buttonText: 'Spotter Quality Manual Monitoring',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.SpotterQualityManualMonitoring,
    shouldDoubleIndent: true,
  };
  const dailyChecklistStep9: IChecklistActionItem = {
    text: 'Are there common errors that everyone is making → Message in slack and explain to everyone the common error they should look for',
    buttonText: '',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.TableauAccess,
    shouldDoubleIndent: true,
  };
  const dailyChecklistStep10: IChecklistActionItem = {
    text: 'Is SAs quality bad?',
    buttonText: '',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.TableauAccess,
    shouldIndent: true,
  };
  const dailyChecklistStep11: IChecklistActionItem = {
    text: 'Demote Super Attempers',
    buttonText: 'Demote: Super Attempters to L0',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.DemoteSuperAttempters,
    shouldDoubleIndent: true,
  };
  const dailyChecklistStep12: IChecklistActionItem = {
    text: 'Are your spotters leaving good inline comments? ',
    buttonText: '',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.DemoteSuperAttempters,
  };
  const dailyChecklistStep13: IChecklistActionItem = {
    text: 'Download spotter comments and analyze trends.',
    buttonText: 'Download spotter comments',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.AnalyzeInlineComments,
    shouldIndent: true,
  };
  const dailyChecklistStep14: IChecklistActionItem = {
    text: 'Can we promote more attempters to SA?',
    buttonText: '',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.DemoteSuperAttempters,
  };
  const dailyChecklistStep15: IChecklistActionItem = {
    text: 'Find attempters to promote',
    buttonText: 'Permission & Assign: Super Attempters',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignSuperAttempters,
    shouldIndent: true,
  };

  const zeroReviewDailySectionChecklist: ISectionChecklist = {
    title: 'Are my super attempters and spotters performing well?',
    children: [
      dailyChecklistStep1,
      dailyChecklistStep2,
      dailyChecklistStep3,
      dailyChecklistStep4,
      dailyChecklistStep5,
      dailyChecklistStep6,
      dailyChecklistStep7,
      dailyChecklistStep8,
      dailyChecklistStep9,
      dailyChecklistStep10,
      dailyChecklistStep11,
      dailyChecklistStep12,
      dailyChecklistStep13,
      dailyChecklistStep14,
      dailyChecklistStep15,
    ],
  };

  // subsection
  const zeroReviewPlaceholder: IGenericSubSection = {
    title: 'Zero Review + Spotter Pipeline: Daily Checklist',
    children: [zeroReviewDailySectionChecklist],
  };

  const mainSection: ISection = {
    title: SectionTitle.ZeroReviewDailyChecklist,
    children: [zeroReviewPlaceholder],
  };
  return mainSection;
};

const createWorkflowLowThroughputSubSection = (): IGenericSubSection => {
  // throughput blocked section checklist

  const actionCorpExplain: IChecklistActionItem = {
    text: 'Check Corp Explain',
    buttonText: 'Corp Explain',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.CorpExplain,
  };
  const actionAllocationExplain: IChecklistActionItem = {
    text: 'Check Allocation Explain',
    buttonText: 'Allocation Explain',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.AllocationExplain,
  };
  const actionMisconfiguredSupplyLevers: IChecklistActionItem = {
    text: 'Check for misconfigured configs and benchmark state',
    buttonText: 'Misconfigured supply levers',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.MisconfiguredSupplyLevers,
  };
  const actionThrottledTasks: IChecklistActionItem = {
    text: 'Check for throttles',
    buttonText: 'Throttles',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.Throttles,
  };
  const triageLongTailTasks: IChecklistTriageItem = {
    text: 'Check whether long tail tasks are consuming excess resources',
    buttonText: 'Long tail tasks',
    checklistType: ChecklistItemType.Triage,
    triageItem: TriageItem.LongTailTasks,
  };
  const actionTriagePausedPermissions: IChecklistActionItem = {
    text: 'Check if contributors have paused your project',
    buttonText: 'Triage Contributor Choice',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.TriagePausedPermissionGroup,
  };
  const throughputBlockedSectionChecklist: ISectionChecklist = {
    title: 'Is throughput blocked?',
    children: [
      actionCorpExplain,
      actionAllocationExplain,
      actionMisconfiguredSupplyLevers,
      actionThrottledTasks,
      triageLongTailTasks,
      actionTriagePausedPermissions,
    ],
  };
  // low conversion courses section checklist
  const triageLowCoursesConversion: IChecklistTriageItem = {
    text: 'Check whether contributors are completing required courses',
    buttonText: 'Low courses conversion',
    checklistType: ChecklistItemType.Triage,
    triageItem: TriageItem.LowCoursesConversion,
  };
  const lowConversionCoursesSectionChecklist: ISectionChecklist = {
    title: 'Low conversion from courses?',
    children: [triageLowCoursesConversion],
  };
  // low conversion benchmarks section checklist
  const triageLowBenchmarkConversion: IChecklistTriageItem = {
    text: 'Check whether contributors are meeting benchmark config requirements',
    buttonText: 'Low benchmark conversion',
    checklistType: ChecklistItemType.Triage,
    triageItem: TriageItem.LowBenchmarkConversion,
  };
  // low conversion benchmark instruction items checklist
  const triageLowInstructionItemBenchmarkConversion: IChecklistTriageItem = {
    text: 'Check whether contributors are meeting instruction item benchmark config requirements',
    buttonText: 'Low instruction item benchmark conversion',
    checklistType: ChecklistItemType.Triage,
    triageItem: TriageItem.LowInstructionItemBenchmarkConversion,
  };
  const lowConversionBenchmarksSectionChecklist: ISectionChecklist = {
    title: 'Low conversion from benchmarks and instruction item benchmarks?',
    children: [triageLowBenchmarkConversion, triageLowInstructionItemBenchmarkConversion],
  };
  // dammit allocation model section checklist
  const actionTableauAccess: IChecklistActionItem = {
    text: 'Check if you have Tableau access',
    buttonText: 'Tableau Access',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.TableauAccess,
  };
  const actionCapacityAllocation: IChecklistActionItem = {
    text: 'Check your manual and automated allocations',
    buttonText: 'Capacity Allocation',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.CapacityAllocation,
  };
  const triageInsufficientCapacityAllocations: IChecklistTriageItem = {
    text: 'Add additional permissions and/or permissions on the project',
    checklistType: ChecklistItemType.Triage,
    buttonText: 'Insufficient capacity allocations',
    triageItem: TriageItem.InsufficientCapacityAllocations,
  };
  const dammitAllocationModelSectionChecklist: ISectionChecklist = {
    title:
      'Do I have enough capacity allocation? Did that damn allocation model give me crowd contributors?',
    children: [
      actionTableauAccess,
      actionCapacityAllocation,
      triageInsufficientCapacityAllocations,
    ],
  };
  // still stuck throughput section checklist
  const actionThroughputOpsProcesses: IChecklistActionItem = {
    text: 'Consider consulting other Ops processes',
    buttonText: 'Check Ops processes',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.ThroughputOpsProcesses,
  };
  const stillStuckThroughputSectionChecklist: ISectionChecklist = {
    title: "I'm here and still stuck. What do I do?",
    children: [actionThroughputOpsProcesses],
  };
  // subsection
  const workflowLowThroughputSubsection: IGenericSubSection = {
    title: 'Workflow: Low Throughput',
    children: [
      throughputBlockedSectionChecklist,
      lowConversionCoursesSectionChecklist,
      lowConversionBenchmarksSectionChecklist,
      dammitAllocationModelSectionChecklist,
      stillStuckThroughputSectionChecklist,
    ],
  };
  return workflowLowThroughputSubsection;
};

const createtriageInsufficientCapacityAllocationsSubsection = (): ITriageSubSection => {
  // checklist action items
  const actionAttempterPermissions: IChecklistActionItem = {
    text: 'Check if there are enough attempters',
    buttonText: 'Permission & Assign: Attempters',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignAttempters,
  };
  const actionReviewerPermissions: IChecklistActionItem = {
    text: 'Check if there are enough reviewers',
    buttonText: 'Permission & Assign: Reviewers',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignReviewers,
  };
  // section checklist
  const addPermissionsSectionChecklist: IActionSectionChecklist = {
    title: 'Are there enough permissions at each level on the project?',
    children: [actionAttempterPermissions, actionReviewerPermissions],
  };
  // subsection
  const triageInsufficientCapacityAllocationsSubsection: ITriageSubSection = {
    title: 'Triage: Insufficient Capacity Allocations',
    children: [addPermissionsSectionChecklist],
  };
  return triageInsufficientCapacityAllocationsSubsection;
};

const createTriageLowCoursesConversionSubSection = (): ITriageSubSection => {
  const actionCheckAllCourses: IChecklistActionItem = {
    text: 'Do a quick sanity check of all the courses',
    buttonText: 'All project courses',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.AllProjectCourses,
  };
  const actionCheckInstructionUpdateChangelog: IChecklistActionItem = {
    text: 'Do a quick sanity check of the instruction updates changelog',
    buttonText: 'Instruction update changelog',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.InstructionUpdateChangelog,
  };
  const actionCourseStarts: IChecklistActionItem = {
    text: 'Check course starts',
    buttonText: 'Course starts',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.CourseStarts,
  };
  const actionCoursePath: IChecklistActionItem = {
    text: 'Check for too many courses per new user',
    buttonText: 'Course path',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.CoursePath,
  };
  const actionBlockingPointsCourses: IChecklistActionItem = {
    text: 'Check for blocking points in courses',
    buttonText: 'Course blocking points',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.CourseBlockingPoints,
  };
  const actionCourseScenarios: IChecklistActionItem = {
    text: 'Check course scenarios',
    buttonText: 'Course scenarios',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.CourseScenarios,
  };
  // section checklist
  const courseProgressSectionChecklist: IActionSectionChecklist = {
    title: 'Are workers making progress through courses?',
    children: [
      actionCheckAllCourses,
      actionCheckInstructionUpdateChangelog,
      actionCourseStarts,
      actionBlockingPointsCourses,
      actionCourseScenarios,
      actionCoursePath,
    ],
  };
  // subsection
  const triageLowCoursesConversion: ITriageSubSection = {
    title: 'Triage: Low Courses Conversion',
    children: [courseProgressSectionChecklist],
  };
  return triageLowCoursesConversion;
};

const createTriageLowBenchmarkConversionSubSection = (): ITriageSubSection => {
  // checklist action items
  const actionConfigMinNumBenchmarks: IChecklistActionItem = {
    text: 'Configure the mininum required number of benchmarks',
    buttonText: 'Tune min num benchmarks config',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.TuneMinNumBenchmarksConfig,
  };

  const actionConfigBenchmarkDisablingThreshold: IChecklistActionItem = {
    text: 'Configure the benchmark disabling thresholds',
    buttonText: 'Tune disabling thresholds config',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.TuneDisablingThresholdConfig,
  };
  // section checklist
  const configureBenchmarkConfigsSectionChecklsit: IActionSectionChecklist = {
    title: 'Are benchmark and disabling configs tuned properly?',
    children: [actionConfigMinNumBenchmarks, actionConfigBenchmarkDisablingThreshold],
  };
  // subsection
  const triageLowBenchmarkConversion: ITriageSubSection = {
    title: 'Triage: Low Benchmark Conversion',
    children: [configureBenchmarkConfigsSectionChecklsit],
  };
  return triageLowBenchmarkConversion;
};

const createTriageLowInstructionItemBenchmarkConversionSubSection = (): ITriageSubSection => {
  // checklist action items
  const actionCheckAllInstructionItems: IChecklistActionItem = {
    text: 'Do a quick sanity check of all the instruction items',
    buttonText: 'All instruction items',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.InstructionItemManager,
  };
  const actionConfigMinNumInstructionItemBenchmarks: IChecklistActionItem = {
    text: 'Configure the mininum required number of instruction item benchmarks',
    buttonText: 'Tune min num instruction item benchmarks config',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.TuneMinNumInstructionItemBenchmarksConfig,
  };
  const actionConfigInstructionItemBenchmarkDisablingThreshold: IChecklistActionItem = {
    text: 'Configure the instruction item benchmark disabling thresholds',
    buttonText: 'Tune instruction item disabling thresholds config',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.TuneInstructionItemDisablingThresholdConfig,
  };
  // section checklist
  const configureInstructionItemBenchmarkConfigsSectionChecklist: IActionSectionChecklist = {
    title: 'Are benchmark and disabling configs tuned properly?',
    children: [
      actionCheckAllInstructionItems,
      actionConfigMinNumInstructionItemBenchmarks,
      actionConfigInstructionItemBenchmarkDisablingThreshold,
    ],
  };
  // subsection
  const triageLowInstructionItemBenchmarkConversion: ITriageSubSection = {
    title: 'Triage: Low Instruction Item Benchchmark Conversion',
    children: [configureInstructionItemBenchmarkConfigsSectionChecklist],
  };
  return triageLowInstructionItemBenchmarkConversion;
};

const createTriageLongTailTasksSubSection = (): ITriageSubSection => {
  // checklist action items
  const actionCheckForLongTailTasks: IChecklistActionItem = {
    text: 'Identify if long tail tasks are a problem for this queue',
    buttonText: 'LTT Dashboard',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.CheckForLongTailTasks,
  };
  const actionDemoteSuspiciousReviewers: IChecklistActionItem = {
    text: 'Demote reviewers who frequently let through tasks you want to recall',
    buttonText: 'Demote reviewers',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.DemoteSuspiciousReviewers,
  };
  const actionAssignTrustedWorkers: IChecklistActionItem = {
    text: 'Assign long tail tasks to your trusted reviewers',
    buttonText: 'Assign LTT',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.AssignTrustedWorkersLTT,
  };
  const actionCheckAssignRejectionsConfig: IChecklistActionItem = {
    text: 'Update project config to send rejected tasks back to the original attempter',
    buttonText: 'Project config',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.CheckAssignRejectionsConfig,
  };
  const actionSpeedAuditLTT: IChecklistActionItem = {
    text: 'Speed audit long tail tasks from the past day',
    buttonText: 'Speed audit',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.SpeedAuditLTT,
  };
  // section checklist
  const sectionChecklist: IActionSectionChecklist = {
    title: 'Are long tail tasks consuming excess resources?',
    children: [
      actionCheckForLongTailTasks,
      actionDemoteSuspiciousReviewers,
      actionAssignTrustedWorkers,
      actionCheckAssignRejectionsConfig,
      actionSpeedAuditLTT,
    ],
  };
  // subsection
  const triagePlaceholder: ITriageSubSection = {
    title: 'Triage: Long Tail Tasks',
    children: [sectionChecklist],
  };
  return triagePlaceholder;
};

const createTriagePlaceholderSubSection = (): ITriageSubSection => {
  // checklist action items
  const actionPlaceholder: IChecklistActionItem = {
    text: 'This is a placeholder action item for placeholder triage',
    buttonText: 'A button',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.Placeholder,
  };
  // section checklist
  const sectionChecklistPlaceholder: IActionSectionChecklist = {
    title: 'This is a placeholder section checklist',
    children: [actionPlaceholder],
  };
  // subsection
  const triagePlaceholder: ITriageSubSection = {
    title: 'Triage: Placeholder -- TODO',
    children: [sectionChecklistPlaceholder],
  };
  return triagePlaceholder;
};

const createQualityLintingSection = (): IGenericSubSection => {
  // subsection
  const activeLinters: IChecklistActionItem = {
    text: 'Check what linters the project currently has',
    buttonText: 'Active linters',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.LinterConfig,
  };
  const debugLinters: IChecklistActionItem = {
    text: 'Check if linters are blocking throughput',
    buttonText: 'Debug linters',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.LinterDebugging,
  };
  const activeLintersChecklist: ISectionChecklist = {
    title: 'Check active linters',
    children: [activeLinters, debugLinters],
  };
  const tuneLinter: IChecklistActionItem = {
    text: 'Test linters before adding them to the project',
    buttonText: 'Test linters',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.TuneLinters,
  };
  const addLinter: IChecklistActionItem = {
    text: 'Add new linters to the project',
    buttonText: 'Add linters',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.LinterConfig,
  };
  const addLinterChecklist: ISectionChecklist = {
    title: 'Add new linters',
    children: [tuneLinter, addLinter],
  };
  const auditResults: IChecklistActionItem = {
    text: 'List and audit tasks which failed lint',
    buttonText: 'Audit lint results',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.AuditLintResults,
  };
  const sendTasksBackToQueue: IChecklistActionItem = {
    text: 'Send low quality tasks back to queue',
    buttonText: 'SBQ tasks',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.MoveTasksInPipeline,
  };
  const demoteTaskers: IChecklistActionItem = {
    text: 'Demote contributors who consistently fail linters',
    buttonText: 'Demote contributors',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.PermissionAndAssignReviewers,
  };
  const addCourses: IChecklistActionItem = {
    text: 'Teach contributors by adding courses',
    buttonText: 'Add courses',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.AllProjectCourses,
  };
  const addRemedialCourses: IChecklistActionItem = {
    text: 'Teach contributors by adding remedial courses',
    buttonText: 'Add remedial courses',
    checklistType: ChecklistItemType.Action,
    actionItem: ActionItem.RemedialCourses,
  };
  const auditLintResultsChecklist: ISectionChecklist = {
    title: 'Take actions on tasks/contributors which failed linters',
    children: [auditResults, sendTasksBackToQueue, demoteTaskers, addCourses, addRemedialCourses],
  };
  // subsection
  const qualityLintingSubSection: IGenericSubSection = {
    title: 'Workflow: Linters',
    children: [activeLintersChecklist, addLinterChecklist, auditLintResultsChecklist],
  };

  return qualityLintingSubSection;
};

const createProblemsSection = (): ISection => {
  const workflowLowThroughputSubsection = createWorkflowLowThroughputSubSection();
  const qualityLintingSection = createQualityLintingSection();
  const triageInsufficientCapacityAllocationsSubsection =
    createtriageInsufficientCapacityAllocationsSubsection();
  const triageLowBenchmarkConversionSubsection = createTriageLowBenchmarkConversionSubSection();
  const triageLowInstructionItemBenchmarkConversionSubsection =
    createTriageLowInstructionItemBenchmarkConversionSubSection();
  const triageLowCoursesConversionSubsection = createTriageLowCoursesConversionSubSection();
  const triageLongTailTasksSubsection = createTriageLongTailTasksSubSection();

  const problemsSection: ISection = {
    title: SectionTitle.Problems,
    children: [
      workflowLowThroughputSubsection,
      qualityLintingSection,
      triageLowCoursesConversionSubsection,
      triageLowBenchmarkConversionSubsection,
      triageLowInstructionItemBenchmarkConversionSubsection,
      triageInsufficientCapacityAllocationsSubsection,
      triageLongTailTasksSubsection,
    ],
  };
  return problemsSection;
};

const overviewSection = createOverviewSection();
export const problemsSection = createProblemsSection();

export const zeroReviewSetupSection = createZeroReviewSetupChecklist();
export const zeroReviewPostSetupSection = createZeroReviewPostSetupChecklist();
export const zeroReviewDailySection = createZeroReviewDailyChecklist();

const throughputSection = createMonitoringThroughputSection();
const qualitySection = createMonitoringQualitySection();
const benchmarksSection = createMonitoringBenchmarksSection();
const trainingSection = createMonitoringTrainingSection();
const incentivesSection = createMonitoringIncentivesSection();
const monitoringSections = [
  throughputSection,
  qualitySection,
  benchmarksSection,
  trainingSection,
  incentivesSection,
];

// NOTE: can only have triage depth of one -- this is enforced with the ITriageSubSection interface
export const triageItemToTriageSubSection: Record<TriageItem, ITriageSubSection> = {
  [TriageItem.InsufficientCapacityAllocations]:
    createtriageInsufficientCapacityAllocationsSubsection(),
  [TriageItem.LowBenchmarkConversion]: createTriageLowBenchmarkConversionSubSection(),
  [TriageItem.LowInstructionItemBenchmarkConversion]:
    createTriageLowInstructionItemBenchmarkConversionSubSection(),
  [TriageItem.LowCoursesConversion]: createTriageLowCoursesConversionSubSection(),
  [TriageItem.Placeholder]: createTriagePlaceholderSubSection(),
  [TriageItem.LongTailTasks]: createTriageLongTailTasksSubSection(),
};

export const spotterPipelineSection = createSpotterPipelineSection();
export const autopilotSection = createAutopilotSection();
export const allSections = [overviewSection, problemsSection, ...monitoringSections];
